<template>
  <div class="overlay-container" v-if="showContactPopup" @click="setContactPopup(false)">
    <div class="contact-modal" @click.stop>
      <div class="modal-content" :class="!success ? 'show-bg': ''">
        <div v-if="!success">
          <div class="form-header">
            <h4>Almost there!</h4>
            <h2>You're a step away from unlocking the free trial!</h2>
          </div>
          <form class="contact-form">
            <div :class="['form-group', (formFields.name.showError ? 'error-field' : '')]">
              <label class="field-label" for="name">Full Name</label>
              <input
                :class="[!formFields.name.showError ? 'tick-icon' : null]"
                type="text"
                v-model="formData.name"
                name="name"
                id="name"
                placeholder="Enter your full name"
                autocomplete="off"
                autofocus
              />
              <p v-if="formFields.name.showError" class="error-msg">{{formFields.name.errorMsg}}</p>
            </div>
            <div :class="['form-group', (formFields.phone.showError ? 'error-field' : '')]">
              <label class="field-label" for="phone">Phone Number</label>
              <input
                :class="[!formFields.phone.showError ? 'tick-icon' : null]"
                type="tel"
                v-model="formData.phone"
                name="phone"
                id="phone"
                placeholder="Enter your phone number"
                autocomplete="off"
                autofocus
              />
              <p v-if="formFields.phone.showError" class="error-msg">{{formFields.phone.errorMsg}}</p>
            </div>
            <div class="form-group consent">
              <p>
                By clicking Submit, you agree to our and
                <a href="/terms" target="_blank">Terms & Conditions</a> and
                <a href="/privacy" target="_blank">Privacy Policy</a>
              </p>
            </div>
            <button type="button" class="submit-btn" @click="submit()">
              Submit
            </button>
          </form>
        </div>
        <div v-else class="success-block">
          <svg><use v-bind="{'xlink:href':'#success-illustration-2'}"></use></svg>
          <p>Our business team will get in touch with you!</p>
          <button type="button" class="close-btn" @click="setContactPopup(false)">
            Okay, Thanks!
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .overlay-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(26, 26, 26, 0.70);
    z-index: var(--slidein-z-index);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contact-modal {
    background:#ffffff;
    max-width: size(600);
    width: 100%;
    margin: size(20);
    position: relative;
    border-radius: size(8);
    background: #FFF;
    box-shadow: 0 size(4) size(20) 0 rgba(0, 0, 0, 0.08);
    animation: slideup 0.3s ease-in-out;

    @keyframes slideup {
      0% {
        opacity: 0;
        transform: translateY(30px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .modal-content {
      padding: size(48);
      &.show-bg {
        background: url('../../assets/campaign/O.png') no-repeat;
        background-position: top right;
      }

      .form-header {
        margin-bottom: size(32);

        h4 {
          color: var(--rs-black-color);
          font-size: size(16);
          font-weight: 400;
          padding-bottom: size(8);
        }
        h2 {
          color: var(--rs-black-color);
          font-size: size(24);
          font-weight: 700;
          max-width: size(400);
          line-height: size(32);
          text-wrap: wrap;
        }
      }

      .contact-form {
        .form-group {
          margin-bottom: size(20);

          &>.error-msg {
            color: var(--onboard-error-color);
            font-size: size(12);
            padding: size(10) 0;
          }

          label {
            display: block;
            color: var(--rs-black-color);
            font-size: size(15);
            font-weight: 500;
            padding-bottom: size(8);
          }

          input {
            display: block;
            width: 90%;
            padding: size(20);
            border: 1px solid #C0C0C0;
            border-radius: size(6);
            font-size: size(14);
            color: var(--rs-black-color);

            &:focus {
              outline: none;
              border-color: #007bff;
            }

            &::placeholder {
              color: #8D8D8D;
            }
          }

          &.consent {
            margin-bottom: size(32);
            max-width: size(245);
            text-wrap: wrap;

            p {
              color: var(--rs-black-color);
              font-size: size(12);
              font-weight: 400;
              line-height: size(20);
            }
            a {
              text-decoration: underline;
            }
          }
        }

        .submit-btn {
          width: 100%;
          font-size: size(12);
          line-height: size(14);
          font-weight: bold;
          padding: size(8) size(12);
          display: inline-block;
          background: var(--rs-cta-blue-color);
          border: size(1) solid var(--rs-cta-blue-color);
          border-radius: size(6);
          color: var(--rs-white-color);
          cursor: pointer;
          @media screen and (min-width: $breakpoint-md) {
            font-size: size(15);
            line-height: size(18);
          }
          @media screen and (min-width: $breakpoint-lg) {
            padding: size(20) size(30);
          }
          &:hover {
            &:after {
              @include move-animation;
            }
          }
          &:after {
            content: '';
            border-width: 0 size(2) size(2) 0;
            display: inline-block;
            padding: size(2.2);
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            margin-left: size(5);
            vertical-align: middle;
            border: solid var(--rs-white-color);
            border-width: 0 size(2) size(2) 0;
            vertical-align: middle;
          }
        }
      }
      .success-block {
        text-align: center;
        p {
          font-size: size(24);
          font-weight: 700;
          line-height: size(36);
          text-wrap: wrap;
          padding: size(24) 0;
        }

        button {
          padding: size(20) size(40);
          color: #0055BF;
          font-size: size(15);
          font-weight: 700;
          border-radius: size(6);
          border: 1px solid #0055BF;
          cursor: pointer;
          outline: none;
        }
      }
    }
  }

  @media screen and (max-width: $breakpoint-sm) {
    .contact-modal {
      margin: size(10);
      max-width: none;
    }

    .contact-modal .modal-content {
      padding: 0 size(20) size(20);
    }
  }
</style>
<script>
import { WebPage } from '@/store/modules/page';
import { FieldHandler } from '@/core/utils/formModels';
import CookieManager from '@/core/utils/cookieManager';


export default {
  name: 'ContactComponent',
  props: {
    showContactPopup: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        email: this.email,
        campaign_id: '',
        campaign_source: '',
      },
      errorMessage: null,
      formContent: true,
      success: false,
      showLoader: false,
      formFields: {
        name: new FieldHandler({
          errorMsg: 'Please enter a full name.',
        }),
        phone: new FieldHandler({
          errorMsg: 'Please enter a valid phone number.',
        }),
        response: new FieldHandler({
          errorMsg: 'Something went wrong!',
        }),
      },
    };
  },
  methods: {
    setContactPopup(val) {
      this.$emit('update:showContactPopup', val);
      if (!val) {
        this.resetForm();
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        phone: '',
      };
    },
    submit() {
      if (this.validateForm()) {
        this.formData.action = 'campaign_lead_action';
        if (CookieManager.getItem('source_id')) {
          this.formData.campaign_id = CookieManager.getItem('source_id');
        }
        if (CookieManager.getItem('source_medium')) {
          this.formData.campaign_source = CookieManager.getItem('source_medium');
        }
        WebPage.postCampaignDetails(this.$apiInstance, this.formData)
          .then((resp) => {
            if (resp) {
              this.success = true;
              this.formContent = false;
            } else {
              this.success = false;
              this.formContent = true;
              this.formFields.response.showError = true;
              this.formFields.response.errorMsg = 'Something went wrong.';
              this.showLoader = false;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    validateForm() {
      let count = 0;
      if (!this.formFields.name.validateField(this.formData.name)) {
        count += 1;
      }
      if (!this.formFields.phone.validateField(this.formData.phone)) {
        count += 1;
      }
      return (count === 0);
    },
  },
  watch: {
    showContactPopup(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
};
</script>
